import script from "./CampoBusca.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoBusca.vue?vue&type=script&setup=true&lang=js"

import "./CampoBusca.vue?vue&type=style&index=0&id=ab0acabe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab0acabe"]])

export default __exports__